import axios from 'axios'
// services
// import AuthService from '../modules/Auth/services/auth'
// constants
import storageNames from '../constants/storageNames'
// axios
export const axiosInstance = axios.create()

const refreshTokenPromise = null
let refreshInterval = null

// Comentado temporalmente
// handled loginOut
// const currentRoute = window.location.pathname
/* const handledLoginOut = () => {
	const donTRedirect = currentRoute.includes('par-q-public')

	// Detener refresh automático al hacer logout
	stopAutoRefresh()

	AuthService.logout({ noRedirect: donTRedirect })
} */

axiosInstance.interceptors.request.use(
	async config => {
		// Determinar el header de API key basado en la URL
		const setApiKeyHeader = () => {
			if (!config.url) return

			const apiKey = process.env.REACT_APP_API_KEY_GW
			const headerName =
				config.url.includes('public') || config.url.includes('/parq/register/user')
					? 'x-api-key'
					: 'Apikey'

			config.headers[headerName] = apiKey
		}

		setApiKeyHeader()

		// User Cognito token
		if (localStorage.getItem(storageNames.cognitoToken)) {
			config.headers.cognito = JSON.parse(localStorage.getItem(storageNames.cognitoToken)).idToken

			return config
		}

		// User Gigya token (prioridad)
		if (localStorage.getItem(storageNames.gigyaToken)) {
			config.headers.Authorization = localStorage.getItem(storageNames.gigyaToken)
			return config
		}

		// User Email Token (fallback)
		if (localStorage.getItem(storageNames.authToken)) {
			config.headers.Authorization = localStorage.getItem(storageNames.authToken)
			return config
		}

		return config
	},
	error => {
		return Promise.reject(error instanceof Error ? error : new Error(error))
	}
)

// handle response error general case
axiosInstance.interceptors.response.use(
	response => {
		// if token email is not updated
		if (response.data.emailToken) {
			localStorage.setItem(storageNames.authToken, response.data.emailToken)
		}

		// Si se obtiene un nuevo token de Gigya, reiniciar refresh automático
		if (response.data.gigyaToken) {
			localStorage.setItem(storageNames.gigyaToken, response.data.gigyaToken)
			startAutoRefresh() // Reiniciar refresh automático
		}

		return response
	},
	error => {
		return Promise.reject(error instanceof Error ? error : new Error(error))
	}
)

// Función para refrescar token usando Gigya API
const refreshGigyaToken = () => {
	return new Promise((resolve, reject) => {
		if (!window.gigya) {
			reject(new Error('Gigya no está disponible'))
			return
		}

		const params = {
			fields: 'firstName,lastName,email,data.docType,data.docNumber',
			expiration: 300, // 5 minutos
			callback: response => {
				if (response && response.id_token) {
					localStorage.setItem(storageNames.gigyaToken, response.id_token)
					// Reiniciar refresh automático con el nuevo token
					startAutoRefresh()
					resolve(response.id_token)
				} else {
					reject(new Error('Error al refrescar token de Gigya'))
				}
			}
		}

		window.gigya.accounts.getJWT(params)
	})
}
// Comentado temporalmente
/* const refreshAccessTokenGigya = _originalRequest => {
	_originalRequest._retry = true

	// Si ya hay un refresh en proceso, esperar a que termine
	if (refreshTokenPromise) {
		return refreshTokenPromise.then(() => {
			// Usar el nuevo token para la request original
			_originalRequest.headers.Authorization = localStorage.getItem(storageNames.gigyaToken)
			return axios(_originalRequest)
		})
	}

	// Crear nueva promesa de refresh usando Gigya API
	refreshTokenPromise = refreshGigyaToken()
		.then(newToken => {
			_originalRequest.headers.Authorization = newToken
			return axios(_originalRequest)
		})
		.catch(error => {
			console.error('Error al refrescar token:', error)
			handledLoginOut()
			throw error
		})
		.finally(() => {
			// Limpiar la promesa cuando termine
			refreshTokenPromise = null
		})

	return refreshTokenPromise
} */

// Función para iniciar refresh automático cada 4 minutos
const startAutoRefresh = () => {
	// Limpiar intervalo anterior si existe
	if (refreshInterval) {
		clearInterval(refreshInterval)
	}

	// Solo si hay token de Gigya
	if (localStorage.getItem(storageNames.gigyaToken)) {
		refreshInterval = setInterval(() => {
			// Solo refrescar si no hay un refresh en proceso
			if (!refreshTokenPromise) {
				refreshGigyaToken().catch(error => {
					console.error('Gigya: Error en refresh automático:', error)
					// Si falla el refresh automático, limpiar el intervalo
					clearInterval(refreshInterval)
					refreshInterval = null
				})
			}
		}, 4 * 60 * 1000) // 4 minutos
	}
}

// Función para detener refresh automático
const stopAutoRefresh = () => {
	if (refreshInterval) {
		clearInterval(refreshInterval)
		refreshInterval = null
	}
}

// Iniciar refresh automático al cargar el módulo
startAutoRefresh()

// Exportar funciones para uso externo
export { startAutoRefresh, stopAutoRefresh, refreshGigyaToken }
